import PropTypes from "prop-types";

import LinksList from "@/components/Elements/LinksList";

import { UserItem } from "./User.type";

const UsersLinksList = ({ users }) => {
  const links = users?.map(({ id, name, email }) => ({
    label: name,
    to: `/users/${id}`,
    popover: email,
  }));

  return <LinksList links={links} />;
};

UsersLinksList.propTypes = {
  users: PropTypes.arrayOf(UserItem),
};

export default UsersLinksList;
